export default __webpack_public_path__ + "static/media/CK1.f787d155.jpg";